import React, { useState } from 'react';
import { useApi } from '../../hooks/useApi';

// ─── Needs Programming Help modal (T2M Kanban, Sprint 21.3, 9/28/26) ─────────
// Per docs/COMS_T2M_Kanban_Design_Decisions_2026-09-28.md — "will need notes
// to pass to club" (Josh's own framing). Same hard-validation pattern as
// Retention's "Confirmed leaving": block the save with a clear inline
// message if notes are empty. Posts to logT2MNeedsProgrammingHelp
// (queries.js), which enforces the same requirement server-side.

export default function T2MNeedsProgrammingModal({ card, onClose, onSaved }) {
  const { post } = useApi();
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function handleSave() {
    if (!notes.trim()) {
      setError('Notes are required — the club needs real specifics to act on, not just a flag.');
      return;
    }
    setSaving(true);
    setError(null);
    try {
      await post('/t2m/kanban/needs-programming-help', { trialId: card.id, notes: notes.trim() });
      onSaved();
    } catch (e) {
      setError(e.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 460, width: '100%' }}>
        <div className="modal-title">
          🏓 Needs Programming Help — <span style={{ color: '#facc15' }}>{card.name}</span>
        </div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 14, lineHeight: 1.4 }}>
          Flag this trial for the club — recommend a specific program, clinic, or open play session.
          This can happen at any point in the trial, before or after first contact.
        </div>

        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, color: '#ef4444', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>
            Notes * (required)
          </div>
          <textarea
            value={notes}
            onChange={e => setNotes(e.target.value)}
            placeholder="What program/clinic/open play should the club recommend, and why?"
            style={{
              width: '100%', background: '#111', border: '1px solid #ef444466',
              color: '#ccc', borderRadius: 5, padding: '7px 8px', fontSize: 12,
              resize: 'none', height: 64, fontFamily: 'inherit', boxSizing: 'border-box',
            }}
          />
        </div>

        {error && <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 12 }}>{error}</div>}

        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : '✓ Flag for Club'}
          </button>
        </div>
      </div>
    </div>
  );
}
